import { useState, useEffect, useCallback } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../../firebase';
import { saveChefProfiles } from '../firestoreActions';

/**
 * Syncs chef profiles from Firestore kdsConfig/chefProfiles.
 * Returns { profiles, setProfiles, loading }.
 */
export function useChefProfiles() {
  const [profiles, setProfilesState] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ref = doc(db, 'kdsConfig', 'chefProfiles');
    const unsub = onSnapshot(ref, snap => {
      const data = snap.exists() ? snap.data() : {};
      setProfilesState(Array.isArray(data.profiles) ? data.profiles : []);
      setLoading(false);
    }, err => {
      console.error('useChefProfiles:', err);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const setProfiles = useCallback(async (updater) => {
    setProfilesState(prev => {
      const next = typeof updater === 'function' ? updater(prev) : updater;
      saveChefProfiles(next);
      return next;
    });
  }, []);

  return { profiles, setProfiles, loading };
}
